import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export class ErrorLog {
  exceptionType: string;
  exceptionMessage: string;
  stackTrace: string;
  location: string;
}

@Injectable({ providedIn: 'root' })
export class ReportProblemService {
  constructor(protected http: HttpClient) {}

  public autoSend(errorLog: ErrorLog): Promise<any> {
    return this.http
      .post('/api/reportProblem/autoSend', errorLog)
      .toPromise()
      .then((d) => {
        console.log('Success sent log');
      })
      .catch((errorRes: Response) => {
        console.log('Fail sent log');
      });
  }
}
